module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views/~/babel-runtime/core-js/symbol.js
// module id = 3493
// module chunks = 0